import { useEffect, useState } from "react";
import socket from "../Components/socket";
import AppLoader from "../Components/AppLoader";
import { apiRequest } from "../../apiService/allApi";

const Referralhis = () => {
  const [user, setUser] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const role = async () => {
    socket.emit("getprofile");

    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const res = await apiRequest(`me`, "GET", null, headers);
    setUser(res.data);

    Allgames(res.data.referral_code);
  };

  const [cardData, setGame] = useState([]);

  const Allgames = async (id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    setIsLoading(true);

    const res = await apiRequest(
      `referral/code/winn/${id}`,
      "GET",
      null,
      headers,
    );
    setGame(res.data);
    setIsLoading(false);
  };

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const time = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });

    return `${newDate}, ${time}`;
  };

  useEffect(() => {
    role();
    //eslint-disable-next-line
  }, []);

  if (cardData == undefined) {
    return null;
  }

  return (
    <div>
      <div className=" mt-1  Orher_page_main_section p-0">
        <div>
          {isLoading ? (
            <div style={{ display: "flex", justifyContent: "center", padding: "60px 0" }}>
              <AppLoader size="lg" color="primary" text="Loading referrals..." />
            </div>
          ) : cardData && cardData?.length == 0 ? (
            <div className="text-center not_found_box_main">
              <img src="./images/not-found.gif" alt="no data" />
              <div className="mt-2">
                <h3 className="font-weight-bold">No Referal History</h3>
                <p>You have no Referal history yet.</p>
              </div>
            </div>
          ) : (
            cardData &&
            cardData.map((card) => {
              return (
                <>
                  <div className="other_pages_card_main" key={card?._id}>
                    <div className="card_date default-date d-block gaming_chat_icon_main border-right pr-3">
                      <p>{dateFormat(card?.createdAt).split(",")[0]}</p>
                      <p>{dateFormat(card?.createdAt).split(",")[1]}</p>
                    </div>
                    <div>
                      <h3>Referral Earning</h3>
                      <p> Earned by:{card?.earned_from.Name}</p>
                    </div>

                    <div className="transaction_right_side_main">
                      <div className="card_rupee ">
                        <div className="d-flex float-right font-8">
                          <div className="text-danger">{card?.losestatus}</div>
                          <div className="text-success">{card?.winstatus}</div>
                          <picture
                            className="ml-1 mb-1"
                            style={{ marginTop: "-5px" }}
                          >
                            <img
                              height="21px"
                              width="21px"
                              src={process.env.PUBLIC_URL + "/images/rupee.png"}
                              alt=""
                            />
                          </picture>
                          <h5 className="pl-2 mb-0 text-success font-weight-bold">
                            +{card?.amount}
                          </h5>
                        </div>
                      </div>
                      <p className="closingbl mt-2">
                        {" "}
                        Cl Bal : <b> {card?.closing_balance.toFixed(2)}</b>
                      </p>
                    </div>
                  </div>
                </>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

export default Referralhis;
